export const validUpdateFields = [
  'id',
  'name',
  'workspace',
  'geofenceCoordinates'
];
